export const defaultHockeyPackSettings = {
  Team: 1,
  HockeyCenter: 2,
  HockeyDefenseman: 2,
  HockeyRightWing: 2,
  HockeyLeftWing: 0,
  Random: 8,
  Gold: 1,
  Silver: 2,
  Base: 0,
  AllStar: 0,
};

export const defaultSoccerPackSettings = {
  Team: 1,
  Defender: 2,
  Midfielder: 2,
  Forward: 2,
  Goalkeeper: 0,
  Random: 8,
  Gold: 1,
  Silver: 2,
  Base: 0,
  AllStar: 0,
};

export const defaultBasketballPackSettings = {
  Team: 1,
  BasketballGuard: 2,
  BasketballForward: 2,
  BasketballCenter: 2,
  Random: 8,
  Gold: 1,
  Silver: 2,
  Base: 0,
  AllStar: 0,
};

export const defaultFootballPackSettings = {
  Team: 1,
  FootballQuarterBack: 2,
  FootballWideReceiver: 2,
  FootballTightEnd: 2,
  FootballRunningBack: 0,
  Random: 8,
  Gold: 1,
  Silver: 2,
  Base: 0,
  AllStar: 0,
};

export const defaultRugbyPackSettings = {
  Team: 1,
  RugbyFullback: 2,
  RugbyCentre: 2,
  RugbyWing: 2,
  RugbyHalves: 0,
  RugbyHoocker: 0,
  RugbyMiddleForward: 0,
  RugbyEdgeForward: 0,
  Random: 8,
  Gold: 1,
  Silver: 2,
  Base: 0,
  AllStar: 0,
};

export const defaultAustralianFootballPackSettings = {
  Team: 1,
  Defender: 2,
  Midfielder: 2,
  Forward: 2,
  AustralianFootballRuck: 0,
  Random: 8,
  Gold: 1,
  Silver: 2,
  Base: 0,
  AllStar: 0,
};